import PatientOverview from 'dashboard/templates/views/Patient/Overview/PatientOverview';
import store from 'dashboard/store';

export default {
  path: '',
  component: PatientOverview,
  props: true,
  name: 'PatientOverview',
  meta: {
    title: t => t('patient.patientOverview'),
    loggedInOnly: true
  },
  async beforeEnter(to, from, next) {
    const { patientId } = to.params;

    // Go to status screen instead of overview if follow up/SDM still in session
    if (patientId && store.getters['followupSession/type']){
      next(`/patient/${patientId}/record`);
    }else{
      next();
    }
  },
};
